export default from './sticky-footer';



// WEBPACK FOOTER //
// ./app/components/sticky-footer/index.js